import React from "react"
import styled from "styled-components"
import AniLink from "gatsby-plugin-transition-link/AniLink"
import StyledSmallTitle from "../styled/styledSmallTitle"
import { StyledButton } from "../Button"
import Title from "../Title"
import Paragraph from "../styled/styledParagraph"
import aboutUsImg from "../../images/analyzing.svg"

const StyledSection = styled.section`
  margin-top: -88px;
  width: 100%;
  position: relative;
  z-index: 20;
  ${Paragraph} {
    margin-bottom: 32px;
    @media (min-width: 1200px) {
      width: 90%;
    }
  }
  @media (min-width: 768px) {
    width: 90vw;
  }
  @media (min-width: 1200px) {
    margin-top: -282px;
  }
`

const GridBox = styled.div`
  padding: 32px 16px 16px;
  margin-right: 16px;
  background-color: #fff;
  box-shadow: 0 12px 18px 0 rgba(0, 0, 0, 0.05), 0 4px 6px 0 rgba(0, 0, 0, 0.1);
  border-radius: 0 8px 8px 0;
  @media (min-width: 768px) {
    padding: 41px 32px;
    margin-right: 0;
  }
  @media (min-width: 1200px) {
    align-items: flex-start;
    grid-column-gap: 0;
    display: grid;
    grid-template-columns: 3fr 2fr;
    padding: 82px 0 82px calc(100% - 108px);
    align-items: center;
    width: 100vw;
    transform: translateX(-45%);
    max-width: 1200px;
  }
`

const ExtendStyledButton = styled(StyledButton)`
  width: 100%;
  color: #474dc4;
  background-color: transparent;
  border: 2px solid #474dc4;
  @media (min-width: 768px) {
    width: 270px;
    & a {
      width: 270px;
      height: 100%;
    }
  }
  @media (min-width: 1024px) {
    margin-top: 40px;
  }
`

const Container = styled.div`
  @media (min-width: 768px) {
    width: calc(576px - 10vw);
    margin: 0 auto;
  }
  @media (min-width: 1024px) {
    width: auto;
  }
`

const AboutUsImage = styled.img`
  display: none;
  @media (min-width: 1200px) {
    display: block;
    transform: translate(-10%, -20px);
    margin-right: 92px;
  }
`

const AboutUs = () => {
  return (
    <StyledSection>
      <GridBox>
        <Container>
          <StyledSmallTitle>O nas</StyledSmallTitle>
          <Title>
            Szukasz niezawodnej agencji interaktywnej? <br /> <span>Jesteś w dobrym miejscu.</span>
          </Title>
          <Paragraph>
            Nis Media to zespół osób, który stawia na sprawdzone oraz innowacyjne rozwiązania w
            dziedzinie Marketingu i E-commerce.
          </Paragraph>
          <Paragraph>
            Nasze działania mają na celu dopasowanie wizerunku Twojej firmy do obecnych standardów
            jakościowych rynku. Zaufały nam już dziesiątki klientów, którzy współpracują z nami do
            dziś.
          </Paragraph>
          <ExtendStyledButton
            as={AniLink}
            cover
            to="/o-nas/"
            bg="#474dc4"
            style={{ textDecoration: "none" }}
          >
            Poznaj nas bliżej
          </ExtendStyledButton>
        </Container>
        <AboutUsImage src={aboutUsImg} alt="Działamy w Dzierżoniowie i okolicach!" title="O nas" />
      </GridBox>
    </StyledSection>
  )
}

export default AboutUs
